import React from 'react';
import styled from 'styled-components';

const GoToList = styled.button`
  background: ${props =>
    props.theme.gradients?.primary || 'linear-gradient(101deg, #e41e84 0%, #ff6633 100%)'};
  border: none;
  border-radius: ${props => props.theme.borderRadius?.full || '50px'};
  padding: ${props => props.theme.spacing?.[3] || '0.75rem'}
    ${props => props.theme.spacing?.[8] || '2rem'};
  font-family: ${props =>
    props.theme.typography?.fontFamily?.heading || "'Hanson Bold', 'Inter', system-ui, sans-serif"};
  font-size: ${props => props.theme.typography?.fontSize?.base || '1rem'};
  font-weight: ${props => props.theme.typography?.fontWeight?.semibold || '600'};
  color: white;
  cursor: pointer;
  box-shadow: ${props =>
    props.theme.boxShadow?.lg ||
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'};
  transition: all ${props => props.theme.animation?.duration?.normal || '300ms'}
    ${props => props.theme.animation?.easing?.ease || 'cubic-bezier(0.4, 0, 0.2, 1)'};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props =>
      props.theme.boxShadow?.xl ||
      '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'};

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    box-shadow: ${props =>
        props.theme.boxShadow?.xl ||
        '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'},
      0 0 0 3px rgba(249, 115, 22, 0.3);
  }
`;

const WaitlistBtn = () => {
  const scrollToWaitlist = () => {
    const waitlistSection = document.getElementById('waitlist-section');
    if (waitlistSection) {
      waitlistSection.scrollIntoView({behavior: 'smooth'});
    } else {
      // Fallback to scroll to bottom
      window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'});
    }
  };

  return <GoToList onClick={scrollToWaitlist}>JOIN WAITLIST ↓</GoToList>;
};

export default WaitlistBtn;
